/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getDepartmentList(params) {
        return HttpService.get(environment.API_DEPARTMENT_LIST, {
            params,
        });
    },
    getStatus(params) {
        return HttpService.get(environment.API_GET_STATUS, {
            params,
        });
    },
    searchRopaList(params) {
        return HttpService.get(environment.API_SEARCH_ROPA, {
            params,
        });
    },

    getBusinessProcessList(params) {
        return HttpService.get(environment.API_ROPA + '/business-process', {
            params,
        });
    },

    // Detail
    getRoPaDetailHeader(activityId) {
        return HttpService.get(
            environment.API_INVENTORY_ROPA + '/detail-header/' + activityId
        );
    },

    getHistoryRopa(params) {
        return HttpService.get(environment.API_INVENTORY_ROPA + '/history', {
            params,
        });
    },

    getHistoryDetail(params) {
        return HttpService.get(
            environment.API_INVENTORY_ROPA + '/history/detail',
            {
                params,
            }
        );
    },
    getRopaDetail(activityId) {
        return HttpService.get(
            environment.API_INVENTORY_ACTIVITY + '/' + activityId
        );
    },

    changeStatusRopa(payload) {
        return HttpService.put(
            environment.API_INVENTORY_ROPA + '/change-status',
            payload
        );
    },

    // Secret
    updateSecret(payload) {
        return HttpService.put(environment.API_ROPA + '/secret-level', payload);
    },

    // Tab 3
    getMasterDocumentType(activityId) {
        return HttpService.get(
            environment.API_ROPA + '/m/reference-document/' + activityId
        );
    },
    updateReferenceDocument(payload) {
        return HttpService.put(
            environment.API_ADD_ACTIVITY + '/reference-document',
            payload
        );
    },
    // Tab 4
    getMasterStorageLocation(activityId) {
        return HttpService.get(
            environment.API_SEARCH_ROPA + '/m/storage-location/' + activityId
        );
    },
    getMasterPrevent(activityId) {
        return HttpService.get(
            environment.API_SEARCH_ROPA +
                '/m/prevent-control-data-detail/' +
                activityId
        );
    },
    getMasterOwner(activityId) {
        return HttpService.get(
            environment.API_SEARCH_ROPA + '/m/owner-access-delete/' + activityId
        );
    },
    updateCollectDataAndDestruction(payload) {
        return HttpService.put(
            environment.API_ROPA + '/collect-data-destruction',
            payload
        );
    },
    //tab5
    getDataControllerDetail() {
        return HttpService.get(
            environment.API_WFSECURE + '/data-controller/detail'
        );
    },

    //ActivityProcess
    getActivityList(id) {
        return HttpService.get(
            environment.API_INVENTORY_ROPA + '/activity/' + id
        );
    },

    //Delete Activity
    deleteActivity(id) {
        return HttpService.delete(environment.API_WFSECURE + '/activity/' + id);
    },

    //Ropa Tab1 Edit
    getDataSubject(id) {
        return HttpService.get(environment.API_ROPA + '/m/data-subject/' + id);
    },
    getOrganizeDataCollection(id) {
        return HttpService.get(
            environment.API_ROPA + '/m/organize-data-collection/' + id
        );
    },
    updateCollectData(payload) {
        return HttpService.put(
            environment.API_GET_ACTIVITY_LIST + 'collect-data',
            payload
        );
    },
    //Ropa Tab2 Edit
    getPersonalData(id) {
        return HttpService.get(
            environment.API_ROPA + '/m/personal-data-option/' + id
        );
    },
    getSensitiveData(id) {
        return HttpService.get(
            environment.API_ROPA + '/m/sensitive-personal-data-option/' + id
        );
    },
    getPersonalDataTopic(id) {
        return HttpService.get(
            environment.API_ROPA + '/m/personal-data-topic/' + id
        );
    },
    updateCategoryPersonalData(payload) {
        return HttpService.put(
            environment.API_ROPA + '/category-personal-data',
            payload
        );
    },
    //Import Activity
    dawnloadTemplete() {
        return HttpService.get(
            environment.API_ROPA_TEMPLATE_MASTER +
                '?templateType=ropa-create-activity',
            { responseType: 'blob' }
        );
    },
    importActivity(payload) {
        return HttpService.post(
            environment.API_ROPA + '/import/activity',
            payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
    },

    exportListActivity(payload) {
        return HttpService.post(environment.API_ROPA + '/export', payload, {
            responseType: 'blob',
        });
    },
    deleteListActivity(payload) {
        return HttpService.patch(environment.API_ROPA + '/delete', payload);
    },

    //dashboard
    getRopaList() {
        return HttpService.get(environment.API_ROPA + '/summary');
    },

    getConsentRopa(params) {
        return HttpService.get(
            environment.API_SEARCH_ROPA + '/summary/consent',
            {
                params,
            }
        );
    },

    getDepartmentRopa(params) {
        return HttpService.get(
            environment.API_SEARCH_ROPA + '/summary/department',
            {
                params,
            }
        );
    },

    getRiskAssessmentStatus(activityId) {
        return HttpService.get(
            environment.API_ROPA + '/risk-assessment/' + activityId
        );
    },

    getDataBase(activityId) {
        return HttpService.get(
            environment.API_ROPA + '/database/' + activityId
        );
    },
};
